'use client';
import dynamic from 'next/dynamic';

// Lazy facade — same pattern as RewardAsideModal/RewardAsideModal.tsx.
//
// The drawer is rendered hidden (open/close via useOpenGoogleReviewModal), so
// its JS chunk doesn't need to be in the initial bundle. ssr: true keeps the
// markup in the server HTML (SEO requirement: hidden modals must be in the
// initial response).
const GoogleReviewAsideModal = dynamic(
  () => import('./GoogleReviewAsideModalImpl'),
  {
    ssr: true,
  },
);

export default GoogleReviewAsideModal;
